module.exports = __webpack_public_path__ + "static/jiva2-66b633af419ccfd54fe667e5a8e31ccf.png";